import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table } from "react-bootstrap";
import LoadingIcon from "../../actions/LoadingIcon";

function ChallengeOverview() {
  const userId = sessionStorage.getItem("Id");
  const token = sessionStorage.getItem("complexToken");
  const [subjects, setSubjects] = useState([]);
  const [challengesBySubject, setChallengesBySubject] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/UserSubjects/${userId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        setSubjects(res.data);
        Promise.all(
          res.data.map((s) =>
            axios
              .get(`/Challenges/Subjects/${s.subjectId}/WebApp`, { headers: { Authorization: `Bearer ${token}` } })
              .then((r) => ({ subjectId: s.subjectId, name: s.subject.subjectName, challenges: r.data }))
              .catch(() => ({ subjectId: s.subjectId, name: s.subject.subjectName, challenges: [] }))
          )
        ).then((results) => {
          const map = {};
          results.forEach((r) => { map[r.subjectId] = r; });
          setChallengesBySubject(map);
          setLoading(false);
        });
      })
      .catch(() => setLoading(false));
  }, []);

  function getStatus(startDate, endDate) {
    const now = new Date();
    const start = new Date(startDate);
    const end = new Date(endDate);
    if (now < start) return { label: "Gepland", color: "#856404", bg: "#fff3cd" };
    if (now > end)   return { label: "Verlopen", color: "#721c24", bg: "#f8d7da" };
    return           { label: "Actief",   color: "#155724", bg: "#d4edda" };
  }

  function formatDate(iso) {
    return new Date(iso).toLocaleDateString("nl-BE", { day: "2-digit", month: "short", year: "numeric" });
  }

  if (loading) return <LoadingIcon />;

  const entries = Object.values(challengesBySubject);

  if (entries.length === 0 || entries.every((e) => e.challenges.length === 0)) {
    return <p style={{ color: "#888", marginTop: "1rem" }}>Nog geen quizzen aangemaakt.</p>;
  }

  return (
    <div style={{ marginTop: "1.5rem" }}>
      {entries.map((entry) => (
        entry.challenges.length > 0 && (
          <div key={entry.subjectId} style={{ marginBottom: "2rem" }}>
            <h6 style={{ color: "#2d5971", fontWeight: "700", marginBottom: "0.5rem" }}>{entry.name}</h6>
            <Table bordered size="sm" style={{ fontSize: "0.9rem" }}>
              <thead style={{ backgroundColor: "#f0f4f7" }}>
                <tr>
                  <th>Quiz</th>
                  <th>Van</th>
                  <th>Tot</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {entry.challenges.map((c) => {
                  const status = getStatus(c.startDate, c.endDate);
                  return (
                    <tr key={c.id}>
                      <td>{c.title}</td>
                      <td>{formatDate(c.startDate)}</td>
                      <td>{formatDate(c.endDate)}</td>
                      <td>
                        <span style={{
                          backgroundColor: status.bg,
                          color: status.color,
                          padding: "0.2rem 0.6rem",
                          borderRadius: "4px",
                          fontWeight: "600",
                          fontSize: "0.8rem",
                        }}>
                          {status.label}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        )
      ))}
    </div>
  );
}

export default ChallengeOverview;
